
import { useEffect, useState } from 'react';

export function WelcomeHero() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="relative overflow-hidden">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-secondary via-[#1e2d40] to-secondary"></div>
      
      {/* Subtle pattern overlay */}
      <div className="absolute inset-0 opacity-[0.04]" style={{
        backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
        backgroundSize: '40px 40px'
      }}></div>

      {/* Glowing orbs */}
      <div className="absolute top-20 left-1/4 w-72 h-72 bg-primary/10 rounded-full blur-[100px]"></div>
      <div className="absolute bottom-10 right-1/4 w-96 h-96 bg-primary/5 rounded-full blur-[120px]"></div>

      <div className="relative max-w-4xl mx-auto px-6 lg:px-8 py-20 lg:py-28 text-center">
        {/* Success badge */}
        <div
          className={`inline-flex items-center gap-2 bg-primary/15 border border-primary/20 rounded-full px-5 py-2 mb-8 transition-all duration-700 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
        >
          <div className="w-5 h-5 rounded-full bg-primary flex items-center justify-center">
            <i className="ri-check-line text-white text-xs"></i>
          </div>
          <span className="text-primary text-sm font-semibold tracking-wide">Payment Successful</span>
        </div>

        {/* Main heading */}
        <h1
          className={`font-display text-4xl lg:text-5xl xl:text-6xl font-bold text-white mb-6 leading-tight transition-all duration-700 delay-150 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          Welcome to the
          <span className="block text-primary mt-1">Dino Nuggets Family</span>
        </h1>

        <p
          className={`text-gray-300 text-base lg:text-lg max-w-2xl mx-auto leading-relaxed mb-10 transition-all duration-700 delay-300 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          You just made a game-changing decision for your business. Let&apos;s get you set up 
          with a quick onboarding session so we can start delivering results right away.
        </p>

        {/* Scroll indicator */}
        <div
          className={`transition-all duration-700 delay-500 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          <a
            href="#schedule"
            className="inline-flex items-center gap-2 text-primary hover:text-primary/80 transition-colors cursor-pointer group"
          >
            <span className="text-sm font-semibold">Schedule Your Onboarding</span>
            <i className="ri-arrow-down-line text-lg group-hover:translate-y-1 transition-transform"></i>
          </a>
        </div>
      </div>

      {/* Bottom wave */}
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-[#FAFBFC] to-transparent"></div>
    </section>
  );
}
